(function() {

    'use strict';

    angular.module('Services').
    service('CommonService', CommonService)

    CommonService.$inject = ['$filter', 'toastr', 'Shipments', 'ManifestService'];

    function CommonService($filter, toastr, Shipments, ManifestService) {

        return {
            isContainLogo: isContainLogo,
            getFormattedTotalAmount: getFormattedTotalAmount,
            getFormattedAmount: getFormattedAmount,
            isInputInvalid: isInputInvalid,
            printDocuments,
            isDomesticFn: isDomesticFn,
            printLabels: printLabels,
            printConsignmentNote: printConsignmentNote
        };

        function isContainLogo(item) {
            var logoPlaceholder = 'https://placeholdit.imgix.net/~text?txtsize=33&txt=';
            var logoParams = '&w=350&h=150&txtcolor=ffffff&bg=448bc7';
            var defaultLogoUrl = 'http://placehold.it/350x150';
            if (item.serviceDetails) {
                if (item.serviceDetails.logo) {
                    if (item.serviceDetails.logo === defaultLogoUrl) {
                        return logoPlaceholder + item.serviceDetails.carrierName + logoParams;
                    }
                    return item.serviceDetails.logo;
                }
                return logoPlaceholder + item.serviceDetails.carrierName + logoParams;
            } else if (item) {
                if (item.logo === defaultLogoUrl) {
                    return logoPlaceholder + item.carrier + logoParams;
                } else if (item.logo || item.logoUrl || item.carrierName) {
                    return item.logo || item.logoUrl || (logoPlaceholder + item.carrierName + logoParams);
                }
            }
            return logoPlaceholder + "Not Found&w=350&h=150&txtcolor=ffffff&bg=c74468";
        }
        function isInputInvalid(form, name) {
            if(form && form[name]){
                form[name].$commitViewValue();
                return (form[name].$invalid && form.$submitted) || (form[name].$invalid && form[name].$touched);
            }
            return false;
        }
        function getFormattedTotalAmount(data) {
            var sum = data.items.reduce(function(total, item) {
                return total + (item.value * item.quantity);
            }, 0);
            return $filter('bbaCurrency')(sum, '', 2);
        }

        function getFormattedAmount(item) {
            return $filter('bbaCurrency')(item, '', 2);
        }
        function printDocuments(shipment, options) {
            if(!shipment || !angular.isObject(shipment)){
                throw 'Invalid shipment';
            }
            options = angular.extend({
                printLabels: true,
                isReturn: false
            }, options);

            var isPlain = false;
            if(options.isReturn || !isSourceEqualsOfficeAdd(shipment.sourceAddress, shipment.office) ||
                !shipment.office.officeConfiguration.manifesting){
                isPlain = true;
            }
            if(options.printLabels) {
                try{
                    printLabels([shipment.id], isPlain);
                }catch(e){
                    toastr.error('Unable to print'  + (isPlain ? 'plain paper' : 'thermal') + ' label');
                    console.log(e);
                }
                try{
                    if(!isDomesticFn(shipment.sourceAddress, shipment.destinationAddress)) {
                        Shipments.customsDoc([shipment.id]);
                    }
                }catch(e){
                    toastr.error('Unable to print commercial invoice');
                    console.log(e);
                }
                if(shipment.carrierConfiguration != null){
                    if(shipment.carrierConfiguration.hasConsignmentNote){
                        try{
                            printConsignmentNote([shipment.id]);
                        }catch(e){
                            toastr.error('Error', 'Unable to print consignment note');
                            console.log(e);
                        }
                    }
                }
            }

            if(shipment.manifestId) {
                try {
                    ManifestService.downloadManifest(shipment.manifestId);
                } catch(e) {
                    toastr.error('Unable to print manifest document');
                    console.log(e);
                }
            }
        }
        function printLabels(shipmentIds, isPlain, successCallback, errorCallback) {
            var d = new Date().getMilliseconds();
            var fileName = (isPlain ? 'plain-paper-' : 'thermal-') + 'label-' + d;

            Shipments.printLabels({
                shipmentIds: shipmentIds,
                fileName: fileName,
                isPlain: isPlain
            }, successCallback, errorCallback)
        }
        function printConsignmentNote(shipmentIds, successCallback, errorCallback){
            const time = new Date().getMilliseconds();
            const fileName = `consignment-note-${time}`;
            Shipments.printConsignmentNote({
                shipmentIds: shipmentIds,
                fileName: fileName,
            }, successCallback, errorCallback);
        }
        function isDomesticFn(source, destination) {
            var src, dst;
            if (source) {
                src = source.location ? source.location.country : false;
            }
            if (destination) {
                dst = destination.location ? destination.location.country : false;
            }
            return src && dst && src.code === dst.code;
        }
        function isSourceEqualsOfficeAdd (source, office) {
            var hasLocations = source.location && office.location;
            var sameCodes = hasLocations && source.location.code === office.location.code;
            var sameNames = hasLocations && source.location.name ===  office.location.name;
            var sameCountries = hasLocations && source.location.country.code === office.location.country.code;
            var sameStates = function(){
                if(!hasLocations){
                    return false;
                }
                var sourceState = source.location.state ? source.location.state.code : null;
                var officeState = office.location.state ? office.location.state.code : null;
                return sourceState === officeState;
            };
            if(!source || !office){
                throw 'No office or source address';
            }
            if(!source.company || !office.company || source.company !== office.company.name){
                return false;
            }
            if(!angular.isObject(office) && source.location.id === office){
                return true;
            }else if(office.id && source.location.id === office.id){
                return true;
            }else if(!sameCodes || !sameNames || !sameStates() || !sameCountries){
                return false;
            }
            return true;
        }
    }

})();



// WEBPACK FOOTER //
// ./js/services/CommonService.js